import React from "react";
import ModalBox, { ModalBody, ModalHeader } from "../Modal/ModalBox";
import FormikWrapper from "../FormikWrapper";
import Loader from "../Loader";
import { FPSendMailSchema } from "../../formValidation";
import FormInput from "../FormInput";

type loginInputTypes = {
  email: string;
};

interface ForgotPasswordModalPros {
  showModal: boolean;
  btnLoader: boolean;
  successModal?: boolean;
  handleOnSubmit: (value: any) => void;
  closeModal: any;
  signInClick: () => void;
  sendedEmail: string;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalPros> = ({
  showModal,
  handleOnSubmit,
  btnLoader,
  successModal = false,
  closeModal,
  signInClick,
  sendedEmail,
}) => {
  const initialValues: loginInputTypes = {
    email: "",
  };

  if (successModal) {
    return (
      <ModalBox
        show={showModal}
        horizontalAlign="Center"
        closeModal={closeModal}
      >
        <ModalBody>
          <div className="p-4">
            <div className="space-y-6 px-8 pt-4 pb-6">
              <h3 className="font-semibold text-2xl text-center">
                Your forgot password email was sent!
              </h3>
              <p className="px-12 font-normal text-base text-center">
                If the email address has an account, an email will be sent with
                a link to reset your password.
              </p>
              <p className="font-normal text-base text-center">
                Email sent to: <span className="font-bold">{sendedEmail}</span>
              </p>
            </div>
            <div className="px-8 pt-4 border-t border-black text-center">
              <p>Know your password?</p>
              <button type="button" className="underline" onClick={signInClick}>
                sign in now
              </button>
            </div>
          </div>
        </ModalBody>
      </ModalBox>
    );
  } else {
    return (
      <ModalBox
        show={showModal}
        horizontalAlign="Center"
        closeModal={closeModal}
      >
        <ModalHeader>
          <h3 className="p-4 border-b font-bold text-2xl text-center">
            Forgot Password
          </h3>
        </ModalHeader>
        <ModalBody>
          <div className="p-4">
            <FormikWrapper
              initialValues={initialValues}
              validationSchema={FPSendMailSchema}
              onSubmit={handleOnSubmit}
              buttonProps={{
                children: btnLoader ? (
                  <Loader size="small" />
                ) : (
                  <span className="py-1 font-bold text-xl">Send Mail</span>
                ),
                className: "w-full mt-8",
                isDisabled: btnLoader,
              }}
            >
              <FormInput
                label="Email"
                name="email"
                placeholder="Enter Email"
                labelClassName="text-base font-semibold"
                required
              />
            </FormikWrapper>
          </div>
        </ModalBody>
      </ModalBox>
    );
  }
};

export default ForgotPasswordModal;
